import {Dictionary} from '../../types';
import {Item, itemStore} from '../entities/inventory/item';
import {Category, categoryStore} from '../entities/inventory/category';
import {Program, programStore} from '../entities/inventory/program';
import {House, houseStore} from '../entities/inventory/house';
import {getProductSelectionState} from '../../api/inventory/inventoryApi';
import {batchActions} from 'redux-batched-actions';
import {Dispatch} from 'redux';

export interface ProductSelectionState {
  items: Dictionary<Item>;
  categories: Dictionary<Category>;
  programs: Dictionary<Program>;
  houses: Dictionary<House>;
}

export const loadProductSelectionStateData = () => async (dispatch: Dispatch) => {
  const response: ProductSelectionState = await getProductSelectionState();
  const sortedPrograms = Object.fromEntries(Object.entries(response.programs).sort(([, a], [, b]) => a.name.localeCompare(b.name)));
  const sortedHouses = Object.fromEntries(Object.entries(response.houses).sort(([, a], [, b]) => a.name.localeCompare(b.name)));
  await dispatch(batchActions([
    dispatch(programStore.actions.set(sortedPrograms)),
    dispatch(houseStore.actions.set(sortedHouses)),
    dispatch(itemStore.actions.set(response.items)),
    dispatch(categoryStore.actions.set(response.categories))
  ], 'LOAD_PRODUCT_SELECTION_STATE'));
};
